import { render, staticRenderFns } from "./ModalDeletePessoa.vue?vue&type=template&id=5ec128b7"
import script from "./ModalDeletePessoa.vue?vue&type=script&lang=js"
export * from "./ModalDeletePessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports